var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 1650",
    transform: "translate(-241 -2629)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 20",
    cx: 21,
    cy: 21,
    r: 21,
    transform: "translate(241 2629)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.792 2651.191h-2.29c-.37 0-.486-.139-.486-.486v-2.8c0-.37.139-.486.486-.486h2.29v-2.033a5.137 5.137 0 01.624-2.613 3.837 3.837 0 012.059-1.713 5.146 5.146 0 011.781-.3h2.267c.324 0 .463.139.463.463v2.637c0 .324-.139.463-.463.463-.624 0-1.249 0-1.873.023a.835.835 0 00-.948.948c-.023.694 0 1.365 0 2.082h2.683c.37 0 .509.139.509.509v2.8c0 .37-.116.486-.509.486h-2.684v7.54c0 .393-.116.532-.532.532h-2.891c-.347 0-.486-.139-.486-.486v-7.566z",
    fill: "#fff"
  }))));
}
export default SvgFacebookinline;